import React, { useMemo } from 'react';

import { rangePresets } from '@gogame/intl-ts';
import { ScreenLink } from '@gogame/screens';

import { DIMENSION_AFFILIATE } from 'scenes/Trackers/Tracker/constants';
import { trackerLink } from 'scenes/Trackers/Tracker/navigation';

export default ({ children, id, dimension, drillDownId }) => {
  const nextDimension = useMemo(() => {
    if (dimension === 'Concept') {
      return 'CreativeFile';
    }
    if (dimension === 'CreativeFile') {
      return 'Campaign';
    }
  }, [dimension]);

  return (
    <ScreenLink
      link={trackerLink}
      target={'_blank'}
      params={{
        drillPath: [
          { type: dimension, id: drillDownId },
          { type: DIMENSION_AFFILIATE, id: id },
          { type: nextDimension },
        ],
        filtersCollection: [{ period: rangePresets.LAST_30_DAYS.value }],
        ready: true,
      }}
    >
      {children}
    </ScreenLink>
  );
};
